<template>
  <div>
    <b-row>
      <b-col>
        <b-card-group deck>
          <router-link :to="{ name: 'surveyAdd', params: { isNew: 1 }}">
            <b-card align="center" border-variant="primary">Survey Mode</b-card>
          </router-link>
          <div v-if="isAdministrator">
            <router-link :to="{ name: card.uri }" v-for="card in cards" :key="card.key">
              <b-card align="center" border-variant="primary">{{ card.name }}</b-card>
            </router-link>
          </div>
          <div v-if="isAdministrator">
            <router-link :to="{ name: 'surveyAdd', params: { isNew: 0 }}">
              <b-card align="center" border-variant="primary">Manage Surveys</b-card>
            </router-link>
          </div>
        </b-card-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
//import { EventBus } from "@/components/event-bus.js";
import { mapGetters } from 'vuex';

export default {
  
  name: "surveyMenu",
  
  data() { return {
    isAdmin: false,
    cards: [{ key: 1, name: "Locations", uri: "locations" }]
  }},
  computed: mapGetters('account', ['isAdministrator']),
  created() {

      
      // let roles = localStorage.roles;
      // if (roles == "Administrator") {
      //   this.isAdmin = true;
      // }
      // else {
      //   this.isAdmin = false;
      // }
      // this.$nextTick();
    
  }
};
</script>

<style scoped>
.row {
  text-align: center;
}
